import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getDimensionsVariables = async () => {
  const response = await axios.get('/admin/dimensionsVariables/liste')
    .catch((e) => {
      throw new CustomException(e, 'Error fetching dimensionsVariables')
    })
  return response.data
}

export const setDimensionsVariables = async data => {
  const response = await axios.post('/admin/dimensionsVariables/update', { data })
    .catch((e) => {
      throw new CustomException(e, 'Error fetching dimensionsVariables')
    })
  return response.data
}
